import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { ProductService } from 'src/app/core/api/product/product.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { BusinessSummaryResponseDTO } from 'src/app/shared/models/dtos/responses/business-summary-response-dto/business-summary-response-dto';
import { BusinessFrozenException } from 'src/app/shared/errors/user-management-service/user-management-service-errors';

@Component({
  selector: 'app-business-equipment-tuple',
  templateUrl: './business-equipment-tuple.component.html',
  styleUrls: ['./business-equipment-tuple.component.scss'],
})
/**
 * Business Equipment Tuple
 */
export class BusinessEquipmentTupleComponent implements OnInit {
  @Input() index!: number;
  @Input() label!: string;
  @Output() removeTuple = new EventEmitter<number | FormGroup>();
  @Input() formGroup?: FormGroup;
  @Input() canRemoveTuple?: boolean;
  @Input() canAddNotes?: boolean;
  @Input() businessSummary?: BusinessSummaryResponseDTO;
  businessRegisterDate?: Date;
  existingEquipment?: boolean;
  displayNote: boolean = false;
  canSave = true;
  canShowDelete = false;

  /**
   * @constructor
   */
  constructor(
    private productService: ProductService,
    private snackbarService: SnackBarService,
    private translocoService: TranslocoService,
    private authService: AuthenticatedUserService
  ) {}

  /**
   * Initializer
   */
  ngOnInit(): void {
    const serialFormControl = this.formGroup?.controls['serial'];
    this.existingEquipment = serialFormControl?.value !== '';
    this.canShowDelete =
      this.authService.isRegionalAdmin() || this.authService.isGlobalAdmin();
  }

  /** Getter
   * @return {FormControl}
   */
  get serial() {
    return this.formGroup?.get('serial') as FormControl;
  }

  /** Getter
   * @return {FormControl}
   */
  get id() {
    return this.formGroup?.get('id');
  }

  /** Getter
   * @return {FormControl}
   */
  get planModel() {
    return this.formGroup?.get('planModel');
  }

  /** Getter
   * @return {FormControl}
   */
  get familyName() {
    return this.formGroup?.get('familyName');
  }

  /** Getter
   * @return {FormControl}
   */
  get serialRegisterDate() {
    this.registerDate();
    return this.formGroup?.get('registerDate');
  }

  /** Getter
   * @return {FormControl}
   */
  get note() {
    return this.formGroup?.get('note');
  }

  /**
   * Business Register Date
   */
  registerDate() {
    this.businessRegisterDate = this.businessSummary?.registerDate;
  }

  /**
   * Toggle Note
   */
  toggleNote() {
    this.displayNote = !this.displayNote;
  }

  /**
   * Save Note
   * @param {string} note
   */
  saveNote(note: string) {
    this.canSave = false;
    if (this.note?.value !== note) {
      this.productService.putNoteEquipment(this.id?.value, note).subscribe({
        error: (error) => {
          this.canSave = true;
          if (error instanceof BusinessFrozenException) {
            this.snackbarService.error(
              this.translocoService.translateObject(
                'business-is-frozen-exception'
              )
            );
          } else {
            this.snackbarService.error(
              this.translocoService.translateObject('try-again-later')
            );
          }
        },
        complete: () => {
          this.canSave = true;
          this.snackbarService.success(
            this.translocoService.translateObject('success')
          );
          this.closeNotes();
        },
      });
    }
  }

  /**
   * close Note
   */
  closeNotes() {
    this.displayNote = false;
  }
}
